import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-line text-white text-lg"></i>
            </span>
            <span className={`text-lg md:text-xl font-bold font-heading transition-colors duration-300 ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              51黑料
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
              } ${location.pathname === '/' ? (isScrolled ? 'text-primary-500' : 'text-white') : ''}`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                  isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
                } ${location.pathname === `/category/${cat.slug}` ? (isScrolled ? 'text-primary-500' : 'text-white') : ''}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              } ${location.pathname === '/about' ? (isScrolled ? 'text-primary-500' : 'text-white') : ''}`}
            >
              关于我们
            </Link>
            <Link
              to="/category/mingxing-bagua"
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap ${
                isScrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              <i className="ri-flashlight-line"></i>
              每日黑料大赛
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-500 whitespace-nowrap">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-500 whitespace-nowrap">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-500 whitespace-nowrap">关于我们</Link>
            <Link to="/category/mingxing-bagua" className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 whitespace-nowrap">
              <i className="ri-flashlight-line"></i>
              每日黑料大赛
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}